import * as constants from './constants'

export const scanTicket = ticketNumber => ({
    type: constants.SCAN_TICKET,
    ticketNumber,
})

export const scanTicketSuccess = ticket => ({
    type: constants.SCAN_TICKET_SUCCESS,
    ticket,
})

export const getScanticketLocation = grsId => ({
    type: constants.GET_SCANTICKET_LOCATION,
    grsId,
})

export const getScanticketLocationSuccess = location => ({
    type: constants.GET_SCANTICKET_LOCATION_SUCCESS,
    location,
})

export const redeemScanticketPromo = promoCode => ({
    type: constants.REDEEM_SCANTICKET_PROMO,
    promoCode,
})

export const redeemScanticketPromoSuccess = promo => ({
    type: constants.REDEEM_SCANTICKET_PROMO_SUCCESS,
    promo,
})

export const removeScanticketPromo = () => ({
    type: constants.REMOVE_SCANTICKET_PROMO,
})

export const buyScanticket = (paymentMethod, successCallback, personalDataForm) => ({
    type: constants.BUY_SCANTICKET,
    paymentMethod,
    successCallback,
    personalDataForm,
})

export const clearScanticket = () => ({
    type: constants.CLEAR_SCANTICKET,
})
